<template>
    <div class="home-container-l">
        <carousel :items="1" :autoplay="true" :nav="false" :loop="true">
            <div class="hero-image">
                <img class="img-responsive" src="../../assets/img/banner-ita-spa.jpg">
                <div class="button button-blue button-hero-img">{{$t('BETNOW')}}</div>
            </div>
            <div class="hero-image">
                <img class="img-responsive" src="../../assets/img/banner-bel-fra.jpg">
                <div class="button button-blue button-hero-img">{{$t('BETNOW')}}</div>
            </div>
        </carousel>

        <div class="featured-games">
            <div class="game-banner-item">
                <img class="img-responsive" src="../../assets/img/banner-sport.jpg">
                <h3>{{$t('SPORT')}}</h3>
                <div class="hover-content">
                    <div class="inside">
                        <p>{{$t('PROMOBANNERTEXTSPORT')}}</p>
                        <router-link to="/web/sport/" class="button button-blue button-hero-img">{{$t('BETNOW')}}</router-link>
                    </div>
                </div>
            </div>
            <div class="game-banner-item">
                <img class="img-responsive" src="../../assets/img/banner-live.jpg">
                <h3>{{$t('LIVE')}}</h3>
                <div class="hover-content">
                    <div class="inside">
                        <p>{{$t('PROMOBANNERTEXTLIVE')}}</p>
                        <router-link to="/web/live/" class="button button-blue button-hero-img">{{$t('BETNOW')}}</router-link>
                    </div>
                </div>
            </div>
            <div class="game-banner-item">
                <img class="img-responsive" src="../../assets/img/banner-horses.jpg">
                <h3>{{$t('VHORSES')}}</h3>
                <div class="hover-content">
                    <div class="inside">
                        <p>{{$t('PROMOBANNERTEXTVHORSES')}}</p>
                        <router-link to="/web/horses/" class="button button-blue button-hero-img">{{$t('BETNOW')}}</router-link>
                    </div>
                </div>
            </div>
            <div class="game-banner-item">
                <img class="img-responsive" src="../../assets/img/banner-lotto.jpg">
                <h3>{{$t('LOTTO')}}</h3>
                <div class="hover-content">
                    <div class="inside">
                        <p>{{$t('PROMOBANNERTEXTLOTTO')}}</p>
                        <router-link to="/web/lotto/" class="button button-blue button-hero-img">{{$t('BETNOW')}}</router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="home-live-bets">
            <div class="heading-pulse homepage-heading">
                <div class="blob"></div>
                <h3>{{$t('LIVESPECIALEVENTS')}}</h3>
            </div>
            <div class="home-live-container" >
                <template v-for="matchId in liveMatches">
                    <div v-if="matchesIn[matchId]" class="home-live-item lb-sport" :class="'sportbackcolor-'+sportMapping[matchesIn[matchId].sportId]" :key="matchId" :id="matchId">
                        <div class="sport-icon lb-sport homeevent-bg-sporticon" :class="'sporticon-' + sportMapping[matchesIn[matchId].sportId]"></div>
                        <div class="homelive-top">
                            <div class="homelive-top-container">
                                <div class="time">
                                    <p>{{getLiveMinutes(matchesIn[matchId])}}</p>
                                </div>
                                <div class="teams">
                                    <p class="home-team">{{matchesIn[matchId].teamNameOne}}</p>
                                    <p class="away-team">{{matchesIn[matchId].teamNameTwo}}</p>
                                </div>
                                <div class="score" v-if="matchesIn[matchId].metaData">
                                    <div class="home-score">
                                        <p class="current-score" v-if="matchesIn[matchId].metaData.t1GemScr && matchesIn[matchId].metaData.t1GemScr!= null">{{matchesIn[matchId].metaData.t1GemScr}}</p>
                                        <p class="current-score" v-else>{{matchesIn[matchId].metaData.t1Scr}}</p>
                                        <p v-if="matchesIn[matchId].metaData.periods && matchesIn[matchId].metaData.periods.length">{{matchesIn[matchId].metaData.periods[matchesIn[matchId].metaData.periods.length - 1].t1Scr}}</p>
                                    </div>
                                   <div class="away-score">
                                        <p class="current-score" v-if="matchesIn[matchId].metaData.t2GemScr && matchesIn[matchId].metaData.t2GemScr!= null">{{matchesIn[matchId].metaData.t2GemScr}}</p>
                                        <p class="current-score" v-else>{{matchesIn[matchId].metaData.t2Scr}}</p>
                                        <p v-if="matchesIn[matchId].metaData.periods && matchesIn[matchId].metaData.periods.length">{{matchesIn[matchId].metaData.periods[matchesIn[matchId].metaData.periods.length - 1].t2Scr}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="homelive-bottom group-game">
                            <div class="odds-container sport">
                                <Outcome
                                    v-for="outcome in getMatchOutcomes(matchesIn[matchId])"
                                    v-bind:outcome="outcome"
                                    v-bind:match="matchesIn[matchId]"
                                    v-bind:key="outcome.outcomeId"
                                    v-bind:details="false"></Outcome>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <div class="home-offer">
            <!--div class="homepage-heading">
                <h3>Prematch Events</h3>
            </div-->

            <div class="home-offer-container">
                <div class="featured-menu-desktop hidden-800">
                    <div class="menu-item">
                        <img class="img-responsive" src="../../assets/img/euro2020.jpg">
                    </div>
                    <div class="menu-item">
                        <img class="img-responsive" src="../../assets/img/copaamerica.jpg">
                    </div>
                    <div class="menu-item">
                        <img class="img-responsive" src="../../assets/img/banner-welcome-bonus.png">
                    </div>
                </div>

                <div class="offer group-game">
                    <template v-if="Object.keys(hottestBetsByMarketId).length">
                        <div class="mb-lg">
                            <div class="ggame-heading lb-sport sportheading-hottestbets">
                                <div class="hottest-bets-overlay">&nbsp;</div>
                                <span class="ggame-heading-icon sport-icon lb-sport sporticon-bonusone"></span>
                                <h2 class="ggame-heading-text">{{$t('HOTTESTBETS')}}</h2>
                            </div>
                            <div>
                                <template v-for="(matches, marketId) in hottestBetsByMarketId">
                                <div :key="marketId">
                                    <div class="ggame-odds-heading">
                                    <div class="ggame-odds-lheading">{{getMarketName(marketId)}}</div>
                                </div>
                                <div class="ggame-item" v-for="matchId in matches" :key="matchId">
                                    <div class="ggame-item-content">
                                        <div class="ggame-item-text">
                                            <div class="ggame-item-left">
                                                <div class="ggame-inner-top">
                                                    <span class="ggame-heading-icon sport-icon lb-sport" :class="'sporticon-'+sportMapping[matchesIn[matchId].sportId]"></span>
                                                    <div class="ggame-item-teams">
                                                        <span class="first-team">{{matchesIn[matchId].teamNameOne || 'not defined'}} - {{matchesIn[matchId].teamNameTwo || 'not defined'}}</span>
                                                    </div>
                                                </div>
                                                <div class="ggame-inner-bottom">
                                                    <span class="ggame-item-matchid">{{matchesIn[matchId].code}}</span>
                                                    <span class="ggame-item-date">{{$predefinedLocalDateFormat(matchesIn[matchId].matchDate)}}</span>
                                                    <span class="ggame-item-oddscount">+{{matchesIn[matchId].counts.markets}}</span>
                                                </div>
                                            </div>
                                            <div class="odd-stats"
                                            v-if="showOddStats && matchesIn[matchId] != null && matchesIn[matchId].sConn != null && matchesIn[matchId].sConn.match != null && matchesIn[matchId].sConn.match['1'] != null"
                                            @click.stop="openBetradarStatsPage(matchesIn[matchId])">
                                                <i class="iconset icon-statistic"></i>
                                            </div>
                                        </div>
                                        <div class="odds-container sport">
                                            <Outcome
                                                v-for="outcome in matchesIn[matchId].outcomes"
                                                v-bind:outcome="outcome"
                                                v-bind:match="matchesIn[matchId]"
                                                v-bind:key="outcome.outcomeId+'|single'"
                                                v-bind:details="false"></Outcome>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                </template>
                            </div>
                        </div>
                    </template>

                    <template v-if="Object.keys(specialMatchesByMarketId).length">
                        <div class="mb-lg">
                            <div class="ggame-heading lb-sport sportheading-special">
                            <div class="special-bets-overlay">&nbsp;</div>
                            <span class="ggame-heading-icon sport-icon lb-sport sporticon-bonusone"></span>
                            <h2 class="ggame-heading-text">{{$t('SPECIALMATCHES')}}</h2>
                        </div>
                        <div>
                            <template v-for="(matches, marketId) in specialMatchesByMarketId">
                                <div :key="marketId">
                                    <div class="ggame-odds-heading">
                                    <div class="ggame-odds-lheading">{{getMarketName(marketId)}}</div>
                                </div>
                                <div class="ggame-item" v-for="matchId in matches" :key="matchId">
                                    <div class="ggame-item-content">
                                        <div class="ggame-item-text">
                                            <div class="ggame-item-left">
                                                <div class="ggame-inner-top">
                                                    <span class="ggame-heading-icon sport-icon lb-sport" :class="'sporticon-'+sportMapping[matchesIn[matchId].sportId]"></span>
                                                    <div class="ggame-item-teams">
                                                        <span class="first-team">{{matchesIn[matchId].teamNameOne || 'not defined'}} - {{matchesIn[matchId].teamNameTwo || 'not defined'}}</span>
                                                    </div>
                                                </div>
                                                <div class="ggame-inner-bottom">
                                                    <span class="ggame-item-matchid">{{matchesIn[matchId].code}}</span>
                                                    <span class="ggame-item-date">{{$predefinedLocalDateFormat(matchesIn[matchId].matchDate)}}</span>
                                                    <span class="ggame-item-oddscount">+{{matchesIn[matchId].counts.markets}}</span>
                                                </div>
                                            </div>
                                            <div class="odd-stats"
                                            v-if="matchesIn[matchId] != null && matchesIn[matchId].sConn != null && matchesIn[matchId].sConn.match != null && matchesIn[matchId].sConn.match['1'] != null"
                                            @click.stop="openBetradarStatsPage(matchesIn[matchId])">
                                                <i class="iconset icon-statistic"></i>
                                            </div>
                                        </div>
                                        <div class="odds-container sport">
                                            <Outcome
                                                v-for="outcome in matchesIn[matchId].outcomes"
                                                v-bind:outcome="outcome"
                                                v-bind:match="matchesIn[matchId]"
                                                v-bind:key="outcome.outcomeId+'|single'"
                                                v-bind:details="false"></Outcome>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        </div>
                    </template>

                    <template v-if="Object.keys(bonusMatchesByMarketId).length">
                        <div class="ggame-heading lb-sport sportheading-bonusdana">
                            <div class="bonus-bets-overlay">&nbsp;</div>
                            <span class="ggame-heading-icon sport-icon lb-sport sporticon-bonustwo"></span>
                            <h2 class="ggame-heading-text">{{$t('BONUSOFTHEDAY')}}</h2>
                        </div>
                        <div>
                            <template v-for="(matches, marketId) in bonusMatchesByMarketId">
                                <div :key="marketId">
                                    <div class="ggame-odds-heading">
                                    <div class="ggame-odds-lheading">{{getMarketName(marketId)}}</div>
                                </div>
                                <div class="ggame-item" v-for="matchId in matches" :key="matchId">
                                    <div class="ggame-item-content">
                                        <div class="ggame-item-text">
                                            <div class="ggame-item-left">
                                                <div class="ggame-inner-top">
                                                    <span class="ggame-heading-icon sport-icon lb-sport" :class="'sporticon-'+sportMapping[matchesIn[matchId].sportId]"></span>
                                                    <div class="ggame-item-teams">
                                                        <span class="first-team">{{matchesIn[matchId].teamNameOne || 'not defined'}} - {{matchesIn[matchId].teamNameTwo || 'not defined'}}</span>
                                                    </div>
                                                </div>
                                                <div class="ggame-inner-bottom">
                                                    <span class="ggame-item-matchid">{{matchesIn[matchId].code}}</span>
                                                    <span class="ggame-item-date">{{$predefinedLocalDateFormat(matchesIn[matchId].matchDate)}}</span>
                                                    <span class="ggame-item-oddscount">+{{matchesIn[matchId].counts.markets}}</span>
                                                </div>
                                            </div>
                                            <div class="odd-stats"
                                            v-if="matchesIn[matchId] != null && matchesIn[matchId].sConn != null && matchesIn[matchId].sConn.match != null && matchesIn[matchId].sConn.match['1'] != null"
                                            @click.stop="openBetradarStatsPage(matchesIn[matchId])">
                                                <i class="iconset icon-statistic"></i>
                                            </div>
                                        </div>
                                        <div class="odds-container sport">
                                            <Outcome
                                                v-for="outcome in matchesIn[matchId].outcomes"
                                                v-bind:outcome="outcome"
                                                v-bind:match="matchesIn[matchId]"
                                                v-bind:key="outcome.outcomeId+'|single'"
                                                v-bind:details="false"></Outcome>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
            </div>

            <Betslip v-if="betslip" />

        </div>
  </div>
</template>

<script>
import
{
    mapActions,
    mapGetters,
    mapMutations,
}
from 'vuex';

import { Common } from '@om-retail/vue-common';
import carousel from 'vue-owl-carousel';
import moment from 'moment-timezone';
import Betslip from '../components/betslip/Betslip.vue';
import Outcome from '../components/Outcome.vue';

export default {
    name: 'Homepage',
    components: {
        carousel,
        Betslip,
        Outcome,
    },
    data()
    {
        return {
            mostPlayed: [],
            hottestBets: [],
            liveMatches: [],
            bonusMatches: [],
            specialMatches: [],
            fetchMostPlayedInterval: null,
        };
    },
    created()
    {
        const me = this;
        me.initSportOffer();
        me.clearOtherItems([
            'sport',
            'outrights',
        ]);
        me.toggleBetslipDef('simple');
        me.loadBetslipStorageItems({
            type: 'sport',
        });
    },
    beforeDestroy()
    {
        const me = this;
        clearInterval(me.fetchMostPlayedInterval);
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'isMobile',
            'matchesIn',
            'startDate',
            'endDate',
            'offerLoading',
            'offerHandling',
            'sportTree',
            'betslip',
        ]),
        showOddStats()
        {
            const me = this;

            return me.globals != null
            && me.globals.publicConfig != null
            && me.globals.publicConfig.website != null
            && me.globals.publicConfig.website.betradarStatisticsUrl != null;
        },
        hottestBetsByMarketId()
        {
            const me = this;
            return me.groupByMarketId(me.hottestBets);
        },
        bonusMatchesByMarketId()
        {
            const me = this;
            return me.groupByMarketId(me.bonusMatches);
        },
        specialMatchesByMarketId()
        {
            const me = this;
            return me.groupByMarketId(me.specialMatches);
        },

        sportMapping()
        {
            const me = this;
            let val = {};

            if (me.globals
            && me.globals.props
            && me.globals.props.sportMapping)
            {
                val = me.globals.props.sportMapping;
            }

            return val;
        },
    },
    methods:
    {
        ...mapActions(
            {
                initSportOfferInit: 'initSportOffer',
                getOfferByDate: 'getOfferByDate',
                toggleMatchDateCheck: 'toggleMatchDateCheck',
                selectSpecialDate: 'selectSpecialDate',
                clearOtherItems: 'clearOtherItems',
                toggleBetslipDef: 'toggleBetslipDef',
                loadBetslipStorageItems: 'loadBetslipStorageItems',
            },
        ),
        ...mapMutations({
            toggleMatchDateCheck: 'toggleMatchDateCheck',
        }),
        groupByMarketId(matchIds)
        {
            const me = this;
            const byMarket = {};

            for (const matchId of matchIds)
            {
                const preselectedMarket = me.getPreselectedMarket(me.matchesIn[matchId]);
                if (!byMarket[preselectedMarket])
                {
                    byMarket[preselectedMarket] = [];
                }
                byMarket[preselectedMarket].push(matchId);
            }
            return byMarket;
        },
        async initSportOffer()
        {
            const me = this;
            me.fetchMostPlayedInterval = null;
            clearInterval(me.fetchMostPlayedInterval);
            me.toggleMatchDateCheck(false);

            await me.selectSpecialDate({
                date: moment().format('YYYY-MM-DD'),
                setSpecialDate: true,
                setDate: true,
            });

            await me.initSportOfferInit({
                sportState: false,
                acceptedSportEventStatuses: 'active',
            });

            me.fetchMostPlayed();
            me.fetchMostPlayedInterval = setInterval(() =>
            {
                me.fetchMostPlayed();
            }, 1000 * 60 * 5);

            const paramsPrematch = {
                sportState: 'prematch',
                startDate: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
                endDate: moment().utc().add(1, 'day').format('YYYY-MM-DD HH:mm:ss'),
            };
            const paramsLive = {
                sportState: 'live',
            };
            me.getOfferByDate(paramsPrematch);
            me.getOfferByDate(paramsLive);
        },
        async fetchMostPlayed(retry = 1)
        {
            const me = this;
            if (retry > 5)
            {
                return;
            }
            try
            {
                const res = await me.offerHandling.callOffer('/reportingstatistics/getStatisticsById?id=stats_SPORT');

                if (res.error)
                {
                    await me.fetchMostPlayed(retry + 1);
                    return;
                }

                const mostPlayed = [];

                for (const entry of res.data.data)
                {
                // eslint-disable-next-line no-underscore-dangle
                    mostPlayed.push(entry._id);
                }

                me.mostPlayed = mostPlayed;
            }
            catch (error)
            {
                await me.fetchMostPlayed(retry + 1);
            }
        },
        getLiveMinutes(match)
        {
            const me = this;

            let val = Common.formatLiveEventDetails(match);

            if (!val.length
            && (match.metaData.status !== 'NOT_STARTED'
            || (match.metaData.min !== undefined
            && match.metaData.periodStatus !== null)))
            {
                val = me.$t(`WEB_${match.metaData.periodStatus}`);
            }

            return val;
        },
        getPreselectedMarket(match)
        {
            const me = this;

            let firstFound = null;

            if (me.sportTree.marketTree[match.sportId] !== undefined)
            {
                if (me.sportTree.marketTree[match.sportId].markets !== undefined
                && me.sportTree.marketTree[match.sportId].markets.length)
                {
                    for (const marketOut of me.sportTree.marketTree[match.sportId].markets)
                    {
                        if (marketOut.tags !== undefined
                        && marketOut.tags !== null
                        && marketOut.tags.indexOf('preselected') !== -1)
                        {
                            const marketId = parseInt(marketOut.marketId, 10);

                            if (firstFound == null)
                            {
                                firstFound = marketId;
                            }

                            for (const outcome of match.outcomes)
                            {
                                if (outcome.markets.indexOf(marketId) !== -1)
                                {
                                    return marketId;
                                }
                            }
                        }
                    }
                }
            }

            return firstFound;
        },
        getMarketName(marketId, field = 'name')
        {
            const me = this;
            let nameOut = 'not defined';
            let fieldOut = field;

            if (me.globals.publicConfig != null
            && me.globals.publicConfig.website != null
            && me.globals.publicConfig.website.sportOfferMarketOutcomeSettings != null
            && me.globals.publicConfig.website.sportOfferMarketOutcomeSettings[field] != null)
            {
                fieldOut = me.globals.publicConfig.website.sportOfferMarketOutcomeSettings[field];
            }

            if (me.sportTree.markets[marketId] != null
            && me.sportTree.markets[marketId][fieldOut] != null)
            {
                nameOut = me.sportTree.markets[marketId][fieldOut];
            }

            return nameOut;
        },
        openBetradarStatsPage(match)
        {
            const me = this;

            const betradarId = match.sConn.match['1'];
            const langCode = me.globals.langCode.split('-')[0];

            const url = `${me.globals.publicConfig.website.betradarStatisticsUrl}/${langCode}/match/${betradarId}`;

            window.open(url, '_blank').focus();
        },
        formatScore(match, score)
        {
            const me = this;

            let scoreOut = score;

            if (match !== undefined
            && match.matchId !== undefined
            && me.liveMatches[match.matchId] !== undefined
            && me.globals
            && me.globals.props
            && me.globals.props.sportScoringMapping)
            {
                const matchOut = me.liveMatches[match.matchId];

                if (me.globals.props.sportScoringMapping[matchOut.sportId]
                && me.globals.props.sportScoringMapping[matchOut.sportId][score.toString()] !== undefined)
                {
                    scoreOut = me.$t(me.globals.props.sportScoringMapping[matchOut.sportId][score.toString()]);
                }
            }

            return scoreOut;
        },
        getMatchOutcomes: (match) =>
        {
            const outcomes = match.outcomes.slice(0, 3);
            return outcomes.filter((outcome) => outcome.status === 'active');
        },
    },
    watch:
    {
        matchesIn:
        {
            handler()
            {
                const me = this;

                const matchesNum = 4;
                const toDelete = [];

                for (const index in me.liveMatches)
                {
                    if (!me.matchesIn[me.liveMatches[index]]
                    || me.getMatchOutcomes(me.matchesIn[me.liveMatches[index]]).length < 1)
                    {
                        toDelete.push(index);
                    }
                }
                for (const indexDel of toDelete)
                {
                    me.liveMatches.splice(indexDel, 1);
                }

                me.bonusMatches = [];
                me.specialMatches = [];
                for (const key in me.matchesIn)
                {
                    if (me.matchesIn[key] != null)
                    {
                        const match = me.matchesIn[key];
                        // LIVE MATCHES
                        if (match.state === 'live')
                        {
                            if (me.liveMatches.length === matchesNum)
                            {
                                continue;
                            }

                            if (me.liveMatches.includes(key) || me.getMatchOutcomes(match).length < 1)
                            {
                                continue;
                            }

                            me.liveMatches.push(key);
                        }
                        // BONUS MATCHES
                        if (match.matchTags && match.matchTags != null && match.matchTags.includes('bonus1'))
                        {
                            me.bonusMatches.push(key);
                        }

                        // SPECIAL MATCHES
                        if (match.matchTags && match.matchTags != null && match.matchTags.includes('bonus2'))
                        {
                            me.specialMatches.push(key);
                        }
                    }
                }

                // HOTTEST BETS
                for (const matchId of me.mostPlayed)
                {
                    if (me.matchesIn[matchId] != null && !me.hottestBets.includes(matchId))
                    {
                        if (me.hottestBets.length === matchesNum)
                        {
                            break;
                        }
                        me.hottestBets.push(matchId);
                    }
                }
            },
        },
        deep: true,
    },
};
</script>
